import {useMutation} from 'react-query';
import {useLocation, useNavigate} from 'react-router-dom';
import {saledPost} from 'services/myAd/saledPost';
interface IUseSaledPostProps {
  action?: () => void;
}
const useSaledPost = ({action}: IUseSaledPostProps) => {
  const navigate = useNavigate();
  const location = useLocation();

  const isFarm = location.pathname.includes('farm');
  const {mutate: mutateSaled} = useMutation({
    mutationFn: ({guid}: ISaledPost) => {
      return saledPost({guid});
    },
    onSuccess: () => {
      action && action();
      navigate(`/${isFarm ? 'farm' : 'wholesaler'}/my-advertisment`);
    },
  });
  return {mutateSaled};
};

export default useSaledPost;
